export default "__VITE_ASSET__tF2QHrJZ__"